/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Tier_Edit_AriaInputs */

const vi_shop_tier_edit_aria = /** @type {(inputs: Shop_Tier_Edit_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sửa hạng ${i?.name}`)
};

/**

* @param {Shop_Tier_Edit_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_edit_aria = /** @type {((inputs: Shop_Tier_Edit_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Edit_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_edit_aria(inputs)
});